import { ITableColumn } from 'components/table/table.interface'
import { ITabItem } from 'components/tab/tab.interface'
import { formatDateTime } from 'common/common.service'
import {
    IUser,
    IUserActivities,
} from 'repository/common/interface/user.interface'
import { ISTColumn } from 'components/simple-table/simple-table.interface'

export const UAHeaders: ITableColumn<IUser>[] = [
    {
        label: 'User ID',
        accessor: 'userId',
        width: 1, // min width
    },
    {
        label: 'Name',
        accessor: 'name',
        width: 1, // min width
    },
    {
        label: 'Email',
        accessor: 'email',
        width: 1, // min width
    },
    {
        label: 'Site',
        accessor: 'site',
        width: 1, // min width
    },
    {
        label: 'Job Title',
        accessor: 'jobTitle',
        width: 1, // min width
    },
    {
        label: 'Job Category',
        accessor: 'jobCategory',
        width: 1, // min width
        customBuild: (data) => {
            return <div> {data.toUpperCase()} </div>
        },
    },
    {
        label: 'Role',
        accessor: 'role',
        width: 1,
    },
    {
        label: 'Last Active',
        accessor: 'lastActive',
        customBuild: (data) => {
            return <>{formatDateTime(data)}</>
        },
    },
    {
        label: 'Status',
        accessor: 'status',
    },
]

export const TabDataUser: ITabItem[] = [
    {
        label: 'Active',
        key: 'status',
        value: 'active',
        className: 'brand',
        totalData: 13,
    },
    {
        label: 'Suspended',
        key: 'status',
        value: 'suspended',
        className: 'yellow',
        totalData: 13,
    },
]

export const UserDetailHeaders: ITableColumn[] = [
    {
        label: 'Select',
        accessor: 'selected',
    },
    {
        label: 'Image',
        accessor: 'image',
    },
    {
        label: 'User ID',
        accessor: 'user_id',
    },
    {
        label: 'Name',
        accessor: 'name',
    },
    {
        label: 'Role',
        accessor: 'role',
    },
    {
        label: 'Organization Name',
        accessor: 'organization_name',
    },
    {
        label: 'Status',
        accessor: 'status',
    },
    {
        label: 'Last Access',
        accessor: 'last_access',
    },
    {
        label: 'Address',
        accessor: 'address',
    },
    {
        label: 'Module Adjusment',
        accessor: 'module_access',
    },
    {
        label: 'Log',
        accessor: 'log',
    },
    {
        label: 'Email Address',
        accessor: 'email',
    },
    {
        label: 'Phone Number',
        accessor: 'phone_number',
    },
]

export const ButtonActionName = [
    'CONTACT USER',
    'EDIT USER',
    'RESET PASSWORD',
    'SUSPEND USER',
    'REMOVE USER',
]

export const tabItemsInitial: ITabItem[] = [
    {
        label: 'Active',
        key: 'status',
        value: 'Active',
        totalData: 35,
        className: 'brand',
    },
    {
        label: 'Suspended',
        key: 'status',
        value: 'Suspended',
        totalData: 15,
        className: 'yellow',
    },
]

export const userActivityHeaders: ISTColumn<IUserActivities>[] = [
    {
        accessor: 'timestamp',
        label: 'Time',
        customBuild: (data) => {
            return <>{formatDateTime(data as string)}</>
        },
    },
    {
        accessor: 'module',
        label: 'Module',
    },
    {
        accessor: 'action',
        label: 'Action',
    },
    {
        accessor: 'description',
        label: 'Descriptions',
    },
]
